<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body {
  background-color:rgb(237, 245, 255);
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue